/**
 * バンドルミックスマッチ設定画面　プロモーションNo取得VOクラス
 */
export class KYMW1308GetPromotionNoModel {
  /** 受注コード */
  public orderCode: string = <string>'';
  /** 媒体区分 */
  public mediumType: string = <string>'';
}
